// extracted by mini-css-extract-plugin
module.exports = {"img":"ItemRow_img__ccU6h","bold":"ItemRow_bold__27jNf","greyText":"ItemRow_greyText__2bkds","linkRow":"ItemRow_linkRow__qyAjG"};